// React libraries
import * as React from 'react';
// Custom Styles
import { useStyles } from "./BlueLinkStyles";
// Material-UI Core
import Link from '@mui/material/Link';
export const BlueLink = (props) => {
    const classes = useStyles(props);
    const { onClick } = props;
    return (React.createElement(React.Fragment, null, props.rightIcon ? (React.createElement(Link, { className: classes.blueLink, onClick: onClick },
        React.createElement("p", null,
            props.children,
            " ",
            React.createElement(props.rightIcon, { className: classes.rightIcon }))))
        : (React.createElement(Link, { className: classes.blueLink, onClick: onClick },
            React.createElement("p", null, props.children)))));
};
BlueLink.defaultProps = {
    onClick: () => { },
};
export default React.memo(BlueLink);
